// extracted by mini-css-extract-plugin
export default {"ActivityLogDetailModal":"ActivityLogDetailModal_ActivityLogDetailModal__+19d1"};